import React, { useState } from 'react';
import Select from 'react-select';
import constants from '../../Constants';
import { ALLOWED_BUTCHERY, ALLOWED_BUTCHERY_VOLAILLE } from '../../Pages/Admin/Library';

const getKeyFromValue = (obj, value) => {
    for (const k of Object.keys(obj)) {
        if (obj[k].indexOf(value) !== -1) {
            return k;
        }
    }

    return '';
};

const ChooseCategory = props => {
    const key = getKeyFromValue(props.options, props.filename);
    const nb = key ? props.options[key].length : 0;
    const selected = key ? props.options[key].indexOf(props.filename) : -1;

    const [animal, setAnimal] = useState('Boeuf');

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Choisir un animal</label>
                        <Select
                            options={ALLOWED_BUTCHERY.map(f => ({
                                label: f,
                                value: f
                            }))}
                            onChange={e => setAnimal(e.value)}
                            value={{
                                label: animal,
                                value: animal
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Choisir une pièce</label>
                        <Select
                            options={Object.keys(props.options)
                                .filter(o => {
                                    if (animal === 'Volaille') {
                                        for (const v of ALLOWED_BUTCHERY_VOLAILLE) {
                                            if (o.toLowerCase().indexOf(v.toLowerCase()) !== -1) {
                                                return true;
                                            }
                                        }

                                        return false;
                                    }

                                    return o.toLowerCase().indexOf(animal.toLowerCase()) !== -1;
                                })
                                .sort((a, b) => a.localeCompare(b))
                                .map(f => ({
                                    label: f,
                                    value: f
                                }))}
                            onChange={e => {
                                props.handleSelectOption(e.value);
                                props.handleSelectPiece(e.value);
                            }}
                            value={{
                                label: key,
                                value: key
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="sub">Nom</label>
                        <input
                            type="text"
                            value={props.category}
                            onChange={e => props.handleSelectPiece(e.target.value)}
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="sub">Sous-Titre</label>
                        <input
                            type="text"
                            name="subtitle"
                            value={props.subtitle}
                            onChange={e => props.handleSetSub(e.target.value)}
                            className="form-control"
                        />
                    </div>
                </div>
            </div>
            {!key || (
                <div
                    className="controls"
                    style={{
                        display: nb > 1 ? 'block' : 'none'
                    }}
                >
                    <p>
                        Sélectionnez une image <i className="fa fa-angle-double-right ip5" />
                    </p>
                    <div>
                        {props.options[key].map((f, i) => (
                            <img
                                className={i === selected ? 'fruitSelection active' : 'fruitSelection'}
                                key={f}
                                src={`${constants.cloud_storage}/Assets/Library/Butchery/${f}`}
                                onClick={() => props.handleSwitchOption(i, key)}
                                height="100"
                                alt="butchery"
                            />
                        ))}
                    </div>
                    <hr className="visible-xs" style={{ marginBottom: '-10px' }} />
                </div>
            )}
        </React.Fragment>
    );
};

export default ChooseCategory;
